<template>
  <div class="grid-column-start-2_sm grid-column-end-4_sm flex flex-column justify-items-center vh75">
    <header
      v-if="inviteCode"
      class="my2">
      <h1 class="font-size-8">You&rsquo;ve been invited to <span class="accent-text">{{ org }}</span></h1>
    </header>
    <header
      v-else
      class="my2">
      <h1 class="font-size-8">Add your invite code</h1>
      <p>Don&rsquo;t have an invite code? Email us at <a href="mailto:help@louderthanten.com">help@louderthanten.com</a>.</p>
    </header>
    <p
      v-if="error"
      class="error dark-red-text font-size-4 mb3">{{ error }}</p>
    <form
      class=""
      @submit.prevent="joinOrganization">
      <input
        v-if="inviteCode"
        v-model="code"
        type="hidden">
      <div
        v-else
        class="c1">
        <lw-text-input
          v-validate="'required'"
          :name="'invite'"
          :label="'Invite code'"
          :size="'large'"
          :class="[ 'c1', error ? 'error' : '' ]"
          v-model="code"
          :error="errors.first('invite')"
        />
      </div>
      <div class="flex justify-content-space-between">
        <button
          class="button invisible-button negative-button"
          @click.prevent="cancel">Cancel</button>
        <button
          class="button accent-button large-button"
          type="submit">Join&nbsp;{{ org }}</button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Overlay from '../livewires/Overlay'
import TextInput from '../livewires/TextInput'

export default {
  components: {
    lwTextInput: TextInput,
    lwOverlay: Overlay
  },
  props: {
    inviteCode: {
      type: String,
      default: ''
    },
    inviteOrg: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      code: '',
      error: ''
    }
  },
  computed: {
    ...mapGetters([ 'user' ]),
    org () {
      if (this.inviteOrg) {
        return this.inviteOrg
      } else {
        return 'organization'
      }
    }
  },
  mounted () {
    if (this.inviteCode) {
      this.code = this.inviteCode
    }
  },
  methods: {
    joinOrganization () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let name = ''
          if (this.inviteOrg) {
            const org = this.inviteOrg
            name = org.replace('%20', ' ')
          }
          const payload = {
            code: this.code,
            user: this.user.id,
            avatar: this.user.avatar,
            userName: this.user.displayName,
            name: name
          }
          this.$store.dispatch('joinOrganization', payload).then(response => {
            this.$router.push('/dashboard')
          }).catch(error => {
            this.error = 'That’s an invalid invite code. Try again?'
            console.log(error)
          })
        }
      })
    },
    cancel () {
      this.$router.go(-1)
    }
  }
}
</script>
